import { render, staticRenderFns } from "./Kiyaku.html?vue&type=template&id=caed31fa&scoped=true&"
import script from "./Kiyaku.vue?vue&type=script&lang=ts&"
export * from "./Kiyaku.vue?vue&type=script&lang=ts&"
import style0 from "./Kiyaku.scss?vue&type=style&index=0&id=caed31fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caed31fa",
  null
  
)

export default component.exports